import React, { useEffect, useRef } from 'react'
import { addMouseFlow } from '@orbitalgaming/games-frontend-library'

import CyberDice from './cyberdice/CyberDice'
import useContextUpdate from './context/useContextUpdate'
import { Provider } from './context/createContext'
import { createSocket } from './socket/createSocket'

function App() {
  const WS_URL = '{{SERVER_WS_URL}}'
  const name = 'orbital.cyberdice'
  const socket = useRef<any>(null)
  const { context, receiveMessage, errorCode, handleErrorText } =
    useContextUpdate(socket, name)

  useEffect(() => addMouseFlow(), [])

  useEffect(() => {
    if (!socket.current)
      socket.current = createSocket(
        WS_URL,
        receiveMessage,
        name,
        handleErrorText,
      )
  }, [socket, receiveMessage])

  useEffect(() => {
    console.log(
      '%cV.2.0.2 DG',
      'color: pink; background: black; padding: 5px; border-radius: 8px;',
    )
  }, [])

  return (
    <Provider value={{ context }}>
      <div className='App'>
        <CyberDice
          // history={history}
          // stakesForSocket={stakesForSocket}
          // audioForSocket={audioForSocket}
          errorCode={errorCode}
        />
      </div>
    </Provider>
  )
}
// lib update 2.5.26

export default App
